export enum ErrorCodes {
  // 应用错误
  APP_ERROR = 'APP_ERROR',
  APP_AUTH_ERROR = 'APP_AUTH_ERROR',
  APP_LOAD_ERROR = 'APP_LOAD_ERROR',
  APP_START_ERROR = 'APP_START_ERROR',

  // 插件错误
  PLUGIN_ERROR = 'PLUGIN_ERROR',
  INVALID_PLUGIN = 'INVALID_PLUGIN',
  PLUGIN_LOAD_ERROR = 'PLUGIN_LOAD_ERROR',
  PLUGIN_HOOK_ERROR = 'PLUGIN_HOOK_ERROR',

  // 钩子错误
  HOOK_ERROR = 'HOOK_ERROR',
  INVALID_HOOK = 'INVALID_HOOK',

  // 加载器错误
  INVALID_LOADER = 'INVALID_LOADER',
  AUTH_LOADER_ERROR = 'AUTH_LOADER_ERROR',
  PAGE_LOADER_ERROR = 'PAGE_LOADER_ERROR'
}
